var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"width":"100%"}},_vm._l((Array(10)),function(user,i){return _c('v-icon',{key:i,staticClass:"px-1",attrs:{"large":"","color":i < 8 ? 'grey lighten-1' : '#FF9800'}},[_vm._v(" fa-person ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }